module.exports = __webpack_public_path__ + "static/media/Github.e5d7b714.png";